import "core-js/modules/es6.regexp.split";
import _toConsumableArray from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es6.function.name";
import _objectSpread from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import SideMenu from "./components/side-menu";
import HeaderBar from "./components/header-bar";
import TagsNav from "./components/tags-nav";
import User from "./components/user";
import ABackTop from "./components/a-back-top";
import messageCom from "./components/messageCom";
import Language from "./components/language";
import ErrorStore from "./components/error-store";
import { get_website_data } from "@/api/chuku";
import shopCart from "./components/shopCart";
import { mapMutations, mapActions, mapGetters } from "vuex";
import { getNewTagList, getNextRoute, routeEqual } from "@/libs/util";
import routers from "@/router/routers";
import minLogo from "@/assets/images/logo-min.png";
import maxLogo from "@/assets/images/logo-min.png";
import Fullscreen from "./components/fullscreen";
import routersArr from "../../router/routers"; //本地路由

import menuRoute from "@/router/module/menu";
import config from "@/config"; //import Language from '@/components/main/components/language'
//import { mapActions,mapMutations } from 'vuex'

import "./main.less";
export default {
  name: "Main",
  components: {
    SideMenu: SideMenu,
    HeaderBar: HeaderBar,
    Language: Language,
    TagsNav: TagsNav,
    ErrorStore: ErrorStore,
    User: User,
    ABackTop: ABackTop,
    messageCom: messageCom,
    shopCart: shopCart,
    Fullscreen: Fullscreen
  },
  data: function data() {
    return {
      collapsed: false,
      minLogo: minLogo,
      maxLogo: maxLogo,
      isFullscreen: false,
      spinShow: false,
      config: config,
      img_url: null
    };
  },
  computed: _objectSpread({}, mapGetters(["errorCount"]), {
    hasHomeBg: function hasHomeBg() {
      if (this.$route.name === "home" || this.$route.name === "serviceReport" || this.$route.name === "userHomeReport" || this.$route.name === "productReport") {
        return true;
      } else {
        return false;
      }
    },
    tagNavList: function tagNavList() {
      return this.$store.state.app.tagNavList;
    },
    tagRouter: function tagRouter() {
      return this.$store.state.app.tagRouter;
    },
    userAvator: function userAvator() {
      //
      if (!this.$store.state.user.avatorImgPath) {
        return this.minLogo;
      }

      return this.$store.state.user.avatorImgPath;
    },
    userName: function userName() {
      return this.$store.state.user.userName;
    },
    cacheList: function cacheList() {
      return ["ParentView"].concat(_toConsumableArray(this.tagNavList.length ? this.tagNavList.filter(function (item) {
        return !(item.meta && item.meta.notCache);
      }).map(function (item) {
        return item.name;
      }) : []));
    },
    menuList: function menuList() {
      // let menu=menuRoute;
      // console.log(menu)
      // return menu;
      var menu = this.$store.getters.menuList;
      console.log("菜单", menu);

      for (var i = 0; i < routersArr.length; i++) {
        if (routersArr[i].name === "_home") {
          var _routersArr$i$childre;

          (_routersArr$i$childre = routersArr[i].children).push.apply(_routersArr$i$childre, _toConsumableArray(menu));

          break;
        }
      }

      this.$router.addRoutes(routersArr.concat([{
        path: "*",
        redirect: "/404"
      }]));
      return menu;
    },
    local: function local() {
      return this.$store.state.app.local;
    },
    hasReadErrorPage: function hasReadErrorPage() {
      return this.$store.state.app.hasReadErrorPage;
    },
    unreadCount: function unreadCount() {
      return this.$store.state.user.unreadCount;
    }
  }),
  methods: _objectSpread({
    gotoinfo: function gotoinfo() {
      var routeData = this.$router.push({
        // path: "/deviceman/detailsNew",detailsNbc
        path: "/infodata"
      });
      window.open(routeData.href, "_self");
    }
  }, mapMutations(["setBreadCrumb", "setTagNavList", "addTag", "setLocal", "setHomeRoute"]), mapActions(["handleLogin", "handleGetMenu"]), {
    goHome: function goHome() {
      this.$router.push({
        name: "home"
      });
    },
    changeCallLoading: function changeCallLoading(b) {
      this.spinShow = b;
    },
    turnToPage: function turnToPage(route) {
      localStorage.setItem('country_code', 'xciot-prod-cnsz');
      var _ref = {},
          name = _ref.name,
          params = _ref.params,
          query = _ref.query;
      if (typeof route === "string") name = route;else {
        name = route.name;
        params = route.params;
        query = route.query;
      }

      if (name.indexOf("isTurnByHref_") > -1) {
        window.open(name.split("_")[1]);
        return;
      }

      this.$router.push({
        name: name,
        params: params,
        query: query
      });
    },
    handleCollapsedChange: function handleCollapsedChange(state) {
      console.log("我的路径", state);
      this.collapsed = state;
      this.$store.commit("echartDomResize", state);
    },
    handleCloseTag: function handleCloseTag(res, type, route) {
      if (type === "all") {
        this.turnToPage(this.$config.homeName);
      } else if (routeEqual(this.$route, route)) {
        if (type !== "others") {
          var nextRoute = getNextRoute(this.tagNavList, route);
          this.$router.push(nextRoute);
        }
      }

      this.setTagNavList(res);
    },
    handleClick: function handleClick(item) {
      this.turnToPage(item);
    },
    showHomeFullScreen: function showHomeFullScreen() {
      var main = document.getElementById("main-wrapper");

      if (this.isFullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        if (main.requestFullscreen) {
          main.requestFullscreen();
        } else if (main.mozRequestFullScreen) {
          main.mozRequestFullScreen();
        } else if (main.webkitRequestFullScreen) {
          main.webkitRequestFullScreen();
        } else if (main.msRequestFullscreen) {
          main.msRequestFullscreen();
        }
      }
    },
    checkFull: function checkFull() {
      var isFull = document.fullscreen || document.mozFullScreen || document.webkitIsFullScreen || document.webkitFullScreen || document.msFullScreen; //to fix : false || undefined == undefined

      if (isFull === undefined) isFull = false;
      return isFull;
    }
  }),
  watch: {
    $route: function $route(newRoute) {
      var name = newRoute.name,
          query = newRoute.query,
          params = newRoute.params,
          meta = newRoute.meta;
      this.addTag({
        route: {
          name: name,
          query: query,
          params: params,
          meta: meta
        },
        type: "push"
      });
      this.setBreadCrumb(newRoute);
      this.setTagNavList(getNewTagList(this.tagNavList, newRoute));
      this.$refs.sideMenu.updateOpenName(newRoute.name);
    }
  },
  mounted: function mounted() {
    /**
     * @description 初始化设置面包屑导航和标签导航
     */
    this.setTagNavList();
    this.setHomeRoute(routers); // this.addTag({
    //   route: this.$route
    // })

    this.setBreadCrumb(this.$route); // 设置初始语言

    this.setLocal(this.$i18n.locale); // 如果当前打开页面不在标签栏中，跳到homeName页
    // if (!this.tagNavList.find(item => item.name === this.$route.name)) {
    //   this.$router.push({
    //     name: this.$config.homeName
    //   })
    // }

    var vm = this;

    window.onresize = function () {
      if (!vm.checkFull()) {
        vm.$store.commit("setFullscreen", false);
      } else {
        vm.$store.commit("setFullscreen", true);
      }
    };
  },
  created: function created() {
    var _this = this;

    get_website_data().then(function (res) {
      _this.img_url = "".concat(process.env.NODE_ENV === "development" ? config.baseUrl.dev : process.env.VUE_APP_BUILD === "production" ? config.baseUrl.pro : config.baseUrl.alp).concat(res.body.logo_url);
    });
  }
};